export default "__VITE_ASSET__DOtMfP6z__"